<div class="out" [style.border]="border">
  <input kzInput #input class="fback" [type]="type" [placeholder]="display_placeholder" [(ngModel)]="_model" #emailref="ngModel" (focus)='onFocus()' (blur)="onBlur()" (ngModelChange)="modelChanged($event)">
  <img src="assets/images/search.svg" class="search" alt="">
</div>
